<template>
  <div class="infor fl">
    <AllHeader
      :label="lable"
      :ischage="true"
      :img="img"
      :sublabel="sublabel"
      @getvalue="getvalue"
    />
    <div v-if="istrr">
      <el-table
        :data="list"
        :header-cell-style="{ background: '#FEF8EF', color: '#7C828A' }"
        style="width: 100%; margin-top: 30px"
      >
        <el-table-column
          prop="content.Enterpriseoverview.msg1"
          label="工程名称"
          min-width="70"  show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="content.Enterpriseoverview.msg3"
          label="工程类别"
          min-width="70"  show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="content.Enterpriseoverview.msg4"
          label="建设规模"
          min-width="80" show-overflow-tooltip
        ></el-table-column>
          <el-table-column
              prop="content.Enterpriseoverview.msg5"
              label="开工时间"
              min-width="80"
          ></el-table-column>
          <el-table-column
              prop="content.Enterpriseoverview.msg6"
              label="计划竣工时间"
              min-width="80"
          ></el-table-column>
          <el-table-column
              prop="content.Enterpriseoverview.msg7"
              label="建设地点" show-overflow-tooltip
          ></el-table-column>
          <el-table-column
              prop="content.Enterpriseoverview.msg8"
              label="最终质量目标"
              min-width="80"
          ></el-table-column>
        <el-table-column fixed="right" min-width="60" label="操作">
          <template slot-scope="scope">
            <el-button
              @click="getapply(scope.row)"
              size="small"
              style="color: #194abe">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagetion :total="total" @getpageValue="getpageValue" class="pos-page" />
    </div>
  </div>
</template>

<script>
import AllHeader from "@/components/Modal/AllHeader";
import Pagetion from "@/components/Modal/Pagetion";
import Lineconbgtir from "@/components/Modal/Line";
import Downinpu from "@/components/Modal/Downinpu";
import {
    AchievementReport, //申报列表
    AddAchievementReport, //业绩申报
    achievement, HighqualityReport,//申请业绩申报列表
} from "../utils/api.js";
export default {
  name: "performance",
  components: {
    AllHeader,
    Pagetion,
    // Lineconbgtir,
    // Downinpu,
  },
  data() {
    return {
      showErr: false,
      token: "",
      istrr: true,
      lable: "优质工程创优策划",
      fileList: [],
      total: 0,
      sublabel: "去申报",
      img: "../assets/apple.png",
      list: [],
      file_urls: [],
    };
  },
  mounted() {
    this.token = "Bearer " + localStorage.getItem("TOKEN");
    this.initList(1);
  },
  methods: {
    godeclar(id){
      this.$router.push("/Performancedeclaration?id="+id)
    },
    initList(page) {
      const data = {
        page_size: 10,
        page: page,
      };
        HighqualityReport(data).then((res) => {
        console.log("res",res);
        res.data.forEach(element => {
          //
        });
        this.list = res.data;
        this.total = res.total;
      });
    },
    getpageValue(index) {
      this.initList(index);
    },
    getapply(row) {
      console.log("row",row);
      // window.open(row.file_urls[0]);
      // this.$router.push(`/word_1?id=${row.id}&title=${row.achievement.explain+row.achievement.type}`)

      this.$router.push(`/word_2?id=${row.id}&title=优质工程创优策划&type=achievement`)
    },
    handleAdd(response, file, fileList) {
      console.log(response);
      console.log(file);
      console.log(fileList);
      this.setUrls(fileList);
      // this.fileList = fileList
      // this.ruleForm.business_license = response.data.host + response.data.url
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.setUrls(fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    //获取上传数组
    setUrls(fileList) {
      let urls = [];
      fileList.map((item) => {
        urls.push(item.response.data.host + item.response.data.url);
      });
      this.file_urls = urls;
      console.log(this.file_urls);
    },
    handleError(err, file, fileList) {
      console.log(err, file, fileList);
      this.showErr = true;
      let that = this;
      setTimeout(function () {
        that.showErr = false;
        console.log(that.showErr);
      }, 2000);
      console.log(this.showErr);
    },
    // 提交审核
    onSubmitTap() {
      if (this.file_urls.length) {
        const data = {
          file_urls: [
            "http://gzjzyxh.tooge.cn/uploads/home/achievement_report/xls/202106/17/1623920458_cbYXNNVlSd.xls",
          ],
        };
        console.log(data);
        AddAchievementReport(data)
          .then((res) => {
            console.log(res);
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.file_urls = [];
            this.fileList = [];
          })
          .catch((err) => {
              console.log(err,'err')
              this.$message({
                  message: err,
                  type: "error",
              });
          });
      } else {
        this.$message({
          message: "请上传文档",
          type: "warning",
        });
      }
    },
    getvalue() {
        this.$router.push("/Highqualitydeclaration")
    },
  },
};
</script>

<style scoped lang="less">
.upload {
  margin-top: 40px;
}

.upload-demo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.uploadheader {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    margin-right: 10px;
    color: #71767c;
  }
}

.block-submit {
  margin-top: 36px;
  margin-bottom: 44px;
}
.achievement{
  display: flex;
  flex-wrap: wrap;
  .achievementList{
    width: 422px;
    height: 158px;
    background: #FFFFFF;
    border: 1px dashed #C8CDD5;
    opacity: 1;
    box-sizing: border-box;
    margin-bottom: 20px;
    padding: 20px 24px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    &:nth-child(2n){
      margin-left: 14px;
    }
    .right{
      width: 91px;
      height: 32px;
      background: #FFFFFF;
      opacity: 1;
      border-radius: 6px;
      line-height: 32px;
      cursor: pointer;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
    }
    .gray{
      border: 1px solid #D4DBDD;
      color: #C8CDD5;
    }
    .blue{
      border: 1px solid #194ABE;
      color: #194ABE;
    }
    .left{
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-evenly;
      p{
        &:nth-child(1){
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 29px;
          color: #0C0D0F;
        }
        &:nth-child(2){
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          line-height: 26px;
          color: #194ABE;
        }
        &:nth-child(3),&:nth-child(4){
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 26px;
          color: #7C828A;
        }
      }
    }
  }
}

</style>
